/** Level 1 starts at 10 scramble moves. Level 1200 is 310. */
const START_MOVES = 10;
const FINAL_MOVES = 310;
const LEVEL_MAX = 1200;

const STEPS = [
    { gridSize: 4, difficulty: "EASY", scramble: "Easy", moves: 10 },
    { gridSize: 4, difficulty: "MEDIUM", scramble: "Medium", moves: 35 },
    { gridSize: 4, difficulty: "HARD", scramble: "High", moves: 70 },
    { gridSize: 6, difficulty: "EASY", scramble: "Easy", moves: 40 },
    { gridSize: 6, difficulty: "MEDIUM", scramble: "Medium", moves: 120 },
    { gridSize: 6, difficulty: "HARD", scramble: "High", moves: 220 },
];

const EASY_SPLIT_LEVEL = 80;
const SLICE = 20;

function sliceBand(band) {
    const slices = [];
    let from = band.from;
    while (from <= band.to) {
        const to = Math.min(band.to, from + SLICE - 1);
        slices.push({ ...band, from, to });
        from = to + 1;
    }
    return slices;
}

function movesForLevel(level, levelTo) {
    const total = Math.max(1, Math.min(LEVEL_MAX, Number(levelTo) || LEVEL_MAX));
    if (total <= 1) {
        return FINAL_MOVES;
    }
    const at = Math.min(total, Math.max(1, level));
    const progress = (at - 1) / (LEVEL_MAX - 1);
    return Math.round(START_MOVES + (FINAL_MOVES - START_MOVES) * progress);
}

export function slidingPackBands(levelTo) {
    const total = Math.max(1, Math.min(LEVEL_MAX, Number(levelTo) || LEVEL_MAX));
    const base = Math.floor(total / STEPS.length);
    const extra = total % STEPS.length;
    let start = 1;
    const bands = [];
    STEPS.forEach((step, index) => {
        const size = base + (index < extra ? 1 : 0);
        if (size <= 0) {
            return;
        }
        const from = start;
        const to = start + size - 1;
        start = to + 1;
        if (index === 0 && step.gridSize === 4 && step.difficulty === "EASY" && from <= EASY_SPLIT_LEVEL && to > EASY_SPLIT_LEVEL) {
            bands.push({ ...step, from, to: EASY_SPLIT_LEVEL, moves: 10 });
            bands.push({ ...step, from: EASY_SPLIT_LEVEL + 1, to, moves: 20 });
            return;
        }
        bands.push({ ...step, from, to });
    });
    return bands.flatMap((band) => sliceBand(band).map((slice) => ({
        ...slice,
        moves: movesForLevel(slice.to, total),
    })));
}

export function bandLabel(band) {
    return `Levels ${band.from}–${band.to}: ${band.gridSize}×${band.gridSize}, ${band.scramble} scramble`;
}
